import React from "react";
import { UserPlus } from "@phosphor-icons/react";

const TH = "px-3 py-2 text-[10px] uppercase tracking-widest text-left whitespace-nowrap";
export const money = (n) => `$${Math.round(n || 0).toLocaleString()}`;

function BuyersCell({ buyers }) {
  if (!buyers.length) return <span className="text-red-700 font-bold uppercase text-[10px] tracking-widest">None</span>;
  return <span className="text-[11px]" title={buyers.map((b) => b.firm_name).join(", ")}>{buyers.map((b) => b.firm_name).join(", ")}</span>;
}

export const DemandTable = ({ rows, priceFor, onAddBuyer, canAdd }) => (
  <div className="overflow-x-auto border-2 border-black bg-white" data-testid="demand-table">
    <table className="w-full text-xs min-w-[820px]">
      <thead className="bg-zinc-100">
        <tr>
          <th className={TH}>State</th><th className={TH}>Funnel</th><th className={TH}>Case type</th>
          <th className={TH}>Unmatched</th><th className={TH}>Buyers covering now</th>
          <th className={TH}>Est. missed revenue</th><th className={TH}>Last lead</th><th className={TH} />
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => {
          const id = `${r.state}-${r.funnel}-${r.case_type}`;
          return (
            <tr key={id} className="border-t border-zinc-200" data-testid={`demand-row-${id}`}>
              <td className="px-3 py-2 font-mono font-bold">{r.state}</td>
              <td className="px-3 py-2">{r.funnel_title}</td>
              <td className="px-3 py-2">{r.case_label}</td>
              <td className="px-3 py-2 font-mono font-bold" data-testid={`demand-row-unmatched-${id}`}>
                {r.unmatched}{r.sold_on_marketplace ? <span className="ml-1 font-normal text-zinc-500">({r.sold_on_marketplace} sold on marketplace)</span> : null}
              </td>
              <td className="px-3 py-2 max-w-[220px] truncate" data-testid={`demand-row-buyers-${id}`}><BuyersCell buyers={r.buyers} /></td>
              <td className="px-3 py-2 font-mono" data-testid={`demand-row-missed-${id}`}>{money(r.unmatched * priceFor(r))}</td>
              <td className="px-3 py-2 font-mono text-[11px]">{r.last_lead_at ? new Date(r.last_lead_at).toLocaleDateString() : "—"}</td>
              <td className="px-3 py-2">
                {canAdd && <button type="button" onClick={() => onAddBuyer(r)} data-testid={`demand-row-add-buyer-${id}`}
                        className="border-2 border-black bg-black text-white px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 hover:bg-red-700 hover:border-red-700 transition-colors duration-150">
                  <UserPlus size={11} weight="bold" /> Add buyer
                </button>}
              </td>
            </tr>
          );
        })}
        {!rows.length && (
          <tr><td colSpan={8} className="px-3 py-6 text-center label-mono" data-testid="demand-table-empty">No unmatched leads here in this range.</td></tr>
        )}
      </tbody>
    </table>
  </div>
);
